/**
 * Compteur du bouton « Créer une alerte » : nombre de filtres de la collection
 * qui seront RÉELLEMENT repris dans la modale d'alerte.
 *
 * Pourquoi pas le compteur de « Filtrer (N) » : tous les filtres actifs ne sont
 * pas transmis à l'alerte. Afficher (5) quand deux d'entre eux seront ignorés
 * induirait en erreur — le compteur ne vaut que s'il ne compte que le repris.
 *
 * La règle de reprise est celle d'alerte-site-modal.js, et on la lit CHEZ LUI
 * quand c'est possible (EXCLUDED_FILTER_IDS et FILTER_PARAM_MAP sont statiques
 * sur le custom element, accessibles via customElements.get) pour qu'un
 * changement là-bas se propage ici. Le repli n'existe que si le custom element
 * n'est pas encore défini.
 *
 * Un filtre compte pour 1, quel que soit son nombre de valeurs : une pastille
 * « 500+ Wh » coche six valeurs Shopify et reste un seul critère. Le prix compte
 * pour 1 même avec ses deux bornes.
 */
(function () {
  'use strict';

  // Miroir de alerte-site-modal.js — ces filtres ont leur propre champ dans le
  // formulaire (taille, budget) ou n'ont pas de sens comme critère d'alerte.
  var EXCLUS_PAR_DEFAUT = [
    'filter.p.m.specs.type',
    'filter.p.m.specs.category',
    'filter.p.m.sync.velo_type_type',
    'filter.p.m.specs.taicyc',
    'filter.v.m.taille_du_cycliste.liste',
    'filter.v.price',
    'filter.v.availability',
    'filter.p.m.velo.categorie_secondaire',
    'filter.p.m.filter.en_promo',
  ];
  var MAP_PAR_DEFAUT = {
    type: 'filter.p.m.specs.category',
    category: 'filter.p.m.velo.categorie_secondaire',
  };
  var PARAMS_TAILLE = [
    'filter.p.m.specs.taicyc',
    'filter.v.m.taille_du_cycliste.liste',
    'filter.p.v.m.specs.taicyc',
  ];

  function classeModale() {
    return typeof customElements !== 'undefined' && customElements.get
      ? customElements.get('alerte-site-modal')
      : null;
  }

  function exclus() {
    var C = classeModale();
    return C && C.EXCLUDED_FILTER_IDS ? C.EXCLUDED_FILTER_IDS : new Set(EXCLUS_PAR_DEFAUT);
  }

  function mapDirecte() {
    var C = classeModale();
    return C && C.FILTER_PARAM_MAP ? C.FILTER_PARAM_MAP : MAP_PAR_DEFAUT;
  }

  /**
   * Un filtre dont AU MOINS UNE valeur est un identifiant de groupe Shopify
   * (gid://) est écarté par getAvailableDynamicFilters() — la puissance
   * batterie est dans ce cas, ses tranches étant des groupes. On le déduit du
   * DOM rendu, ce qui évite l'appel réseau que fait la modale.
   */
  function aDesValeursGroupees(param) {
    var cases = document.querySelectorAll('input[name="' + CSS.escape(param) + '"]');
    for (var i = 0; i < cases.length; i++) {
      if (String(cases[i].value).indexOf('gid://') === 0) return true;
    }
    return false;
  }

  function existeDansLaCollection(param) {
    return (
      document.querySelector('[data-filter-id="' + CSS.escape(param) + '"]') !== null ||
      document.querySelector('input[name="' + CSS.escape(param) + '"]') !== null
    );
  }

  function compter() {
    var params = new URLSearchParams(window.location.search);
    var repris = new Set();
    var lesExclus = exclus();
    var laMap = mapDirecte();

    // 1. Type et catégorie : champs dédiés du formulaire, toujours repris.
    Object.keys(laMap).forEach(function (nom) {
      if (params.getAll(laMap[nom]).length > 0) repris.add(laMap[nom]);
    });

    // 2. Taille : un seul champ, quelle que soit la clé qui l'exprime.
    for (var i = 0; i < PARAMS_TAILLE.length; i++) {
      if (params.get(PARAMS_TAILLE[i])) {
        repris.add('taille');
        break;
      }
    }

    // 3. Prix : deux bornes, un seul critère. gte=0 est la borne par défaut de
    // Shopify, la modale l'ignore — on l'ignore aussi.
    var gte = parseInt(String(params.get('filter.v.price.gte') || '').replace(/[^\d]/g, ''), 10);
    if ((gte > 0) || params.get('filter.v.price.lte')) repris.add('prix');

    // 4. Filtres dynamiques : repris s'ils existent dans la collection, ne sont
    // pas exclus, et n'ont pas de valeurs groupées.
    params.forEach(function (_valeur, cle) {
      if (cle.indexOf('filter.') !== 0) return;
      if (repris.has(cle)) return;
      if (lesExclus.has(cle)) return;
      if (cle.indexOf('filter.v.price.') === 0) return;
      if (!existeDansLaCollection(cle)) return;
      if (aDesValeursGroupees(cle)) return;
      repris.add(cle);
    });

    return repris.size;
  }

  function peindre() {
    var cibles = document.querySelectorAll('[data-alert-filter-count]');
    if (!cibles.length) return;
    var n = compter();
    cibles.forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.hidden = n === 0;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', peindre);
  } else {
    peindre();
  }

  // Le bouton vit dans #CollectionAjaxContent : chaque filtrage le reconstruit.
  document.addEventListener('collection:reloaded', peindre);
  window.addEventListener('popstate', function () {
    setTimeout(peindre, 0);
  });
})();
